import axios, { AxiosInstance } from 'axios';
import { END_SESSION_ENDPOINT, KEYCLOAK_CLIENT_ID, TOKEN_ENDPOINT } from './config';
import { normalizeTokenResponse } from './tokenResponse';
import { TAuthTokens, TRawTokenResponse, TTokenClient, TTokenExchangeRequest } from './types';

const keycloakHttp: AxiosInstance = axios.create({
	headers: { Accept: 'application/json' },
});

const postForm = (url: string, form: URLSearchParams): Promise<TRawTokenResponse> =>
	keycloakHttp.post<TRawTokenResponse>(url, form).then((response) => response.data);

export const keycloakTokenClient: TTokenClient = {
	exchangeAuthorizationCode: (payload: TTokenExchangeRequest): Promise<TAuthTokens | null> => {
		const form = new URLSearchParams({
			grant_type: 'authorization_code',
			client_id: KEYCLOAK_CLIENT_ID,
			code: payload.code,
			redirect_uri: payload.redirectUri,
		});
		if (payload.codeVerifier) form.set('code_verifier', payload.codeVerifier);

		return postForm(TOKEN_ENDPOINT, form).then(normalizeTokenResponse);
	},

	requestRefreshedTokens: (refreshToken: string): Promise<TAuthTokens | null> =>
		postForm(
			TOKEN_ENDPOINT,
			new URLSearchParams({
				grant_type: 'refresh_token',
				client_id: KEYCLOAK_CLIENT_ID,
				refresh_token: refreshToken,
			}),
		).then(normalizeTokenResponse),

	endSsoSession: (refreshToken: string): Promise<unknown> =>
		keycloakHttp.post(
			END_SESSION_ENDPOINT,
			new URLSearchParams({
				client_id: KEYCLOAK_CLIENT_ID,
				refresh_token: refreshToken,
			}),
		),
};
